import { Button, Header, Text } from '@rbilabs/universal-components';
import { Pressable, StyleSheet, View } from 'react-native';

import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, primitive, spacing } from 'styles/constants';
export const LoyaltyPartnerTile = ({
  onPress,
  image,
  title,
  description,
  ctaLabel,
  onCTAPress,
  footer,
  iconRight,
}: {
  onPress?: () => void;
  image: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode[];
  ctaLabel?: string;
  onCTAPress?: () => void;
  footer?: React.ReactNode;
  iconRight?: React.ReactNode;
}) => {
  const isMobile = useIsMobileBreakpoint();

  return (
    <View style={styles.container}>
      <Pressable onPress={onPress}>
        <View style={styles.topContainer}>
          <View style={[styles.leftContainer, { width: isMobile ? spacing.$24 : spacing.$32 }]}>
            {image}
          </View>
          <View style={styles.contentContainer}>
            <Header
              variant="headerThree"
              color={getDesignToken('text-default')}
              ellipsizeMode="tail"
              numberOfLines={2}
              mb="$1"
            >
              {title}
            </Header>
            <View style={styles.offersDescription}>
              {description.map((item, index) => (
                <View key={index}>
                  <Text variant="copyTwo">{item}</Text>
                </View>
              ))}
            </View>

            {ctaLabel && (
              <Button
                variant="outline"
                size="sm"
                alignSelf="flex-start"
                minWidth="$24"
                onPress={onCTAPress}
                marginTop={{ base: '$2', md: '$4' }}
                paddingLeft="$6"
                paddingRight="$6"
              >
                {ctaLabel}
              </Button>
            )}
          </View>
          {iconRight && <View style={styles.iconRightContainer}>{iconRight}</View>}
        </View>
      </Pressable>
      {footer}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: primitive.$white,
    borderRadius: 10,
    borderWidth: 0,
    flexDirection: 'column',
  },
  topContainer: {
    width: '100%',
    padding: spacing.$3,
    flexDirection: 'row',
    gap: spacing.$3,
  },
  leftContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentContainer: {
    flex: 1,
  },
  offersDescription: {
    justifyContent: 'space-between',
    gap: spacing.$6,
  },
  iconRightContainer: {
    width: spacing.$6,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
